import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PageWrapper } from "../../components";
import { notificationAction } from "../../actions";

import "./assort.scss";
import { tictellLogin, getCurrenciesApi } from "../Tictell/tictellApi";
import { privateRoutes } from "../../Routes/routing";
import {
  assortAppLoginApi,
  GetAllActiveCollaborationsCount,
} from "../Assort/assortApi";
import { getChildFeatureByName } from "../Snapshot/snapshotApi";
import { StorageService } from "../../api";
import AssortNavigation from "./Navigation/Navigation";
import { ConfirmDialog, LoadingMask } from "../../common";
import Dashboard from "./views/Dashboard/Dashboard";
import Collaboration from "./views/FinishCollaboration/FinishCollaboration";
import Opportunity from "./views/Opportunity/Opportunity";

class Snapshot extends Component {
  state = {
    UserFeatures: [],
    token: "",
    ExpenseCategories: [],
    Currencies: [],
    isLoading: true,
    UserId: -1,
    dialogMessage: "",
  };
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    const firstUrl = this.state.UserFeatures[0];
    var queryString = window.location.href;
    queryString = queryString.toLowerCase().split("assort")[1];
    if (queryString == "") {
      if (firstUrl) {
        const isApp = window.location.hash.toLowerCase().indexOf("apps") > -1;
        this.props.history.push(
          (isApp ? "/apps" : "") + "/assort/" + firstUrl.Url
        );
      }
    }
  }
  componentDidMount() {
    getChildFeatureByName({ featureName: 'assort' })
      .then((res) => {
        this.setState({
          UserFeatures: res.items,
        });
        const { items } = res;
        const firstUrl = items[0];
        var queryString = window.location.href;
        queryString = queryString.toLowerCase().split("assort")[1];
        if (queryString == "") {
          if (firstUrl) {
            const isApp =
              window.location.hash.toLowerCase().indexOf("apps") > -1;
            this.props.history.push(
              (isApp ? "/apps" : "") + "/assort/" + firstUrl.Url
            );
          }
        }
      })
      .catch((err) => console.log("Err ", err));

    let { UserEmail } = this.props.User;
    let Email = UserEmail;
    if (!Email) {
      const User = StorageService.getUser();
      Email = User.Email;
    }
    this.setState({
      UserId: this.props.User.UserId,
    });
    assortAppLoginApi(Email)
      .then((res) => {
        if (res.success) {
          tictellLogin(Email)
            .then((res) => {
              if (res.success) {
                const { access_token } = res.items;
                this.getCurrencies(access_token);
                this.getAllactivecollaborations(access_token);
                this.setState({
                  token: access_token,
                });
              }
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((Err) => console.log("Error ", Err));
  }
  getAllactivecollaborations(access_token) {
    GetAllActiveCollaborationsCount(access_token).then((res) => {
      if (res.success) {
        if (res.items.length === 0) {
          this.setState({
            dialogMessage: this.props.labels.Snapshot_Collaboration_Dialog_Msg,
            isLoading: false,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      }
    });
  }
  getCurrencies(access_token) {
    getCurrenciesApi()
      .then((res) => {
        if (res.success) {
          this.setState({
            Currencies: res.items.map((item) => ({
              ...item,
              value: item.CurrencyId,
              label: item.Name,
            })),
          });
        }
      })
      .catch((err) => console.log("Err ", err));
  }
  handleOkClick = () => {
    this.props.history.push(privateRoutes.dashboard.path);
  };
  render() {
    const { labels, isHelpActive, location } = this.props;
    const {
      UserFeatures,
      token,
      Currencies,
      dialogMessage,
      isLoading,
      UserId,
    } = this.state;
    const hashesList = [
      "#/apps/assort/",
      "#/assort/",
      "#/apps/assort",
      "#/assort",
    ];
    const currentViewHash =
      window.location.hash.toLowerCase().split("/")[1] == "apps"
        ? window.location.hash.toLocaleLowerCase().split("/")[3]
        : window.location.hash.toLocaleLowerCase().split("/")[2];
    return (
      <PageWrapper className={`assort-page`}>
        {isLoading && (
          <div id="loader-wrapper">
            <div test-data-id={"loader"} id="loader" />
          </div>
        )}
        <AssortNavigation
          disabled={`${isLoading ? "disabled" : ""}`}
          labels={labels}
          isHelpActive={isHelpActive}
          UserFeatures={UserFeatures}
        />
        {dialogMessage && (
          <ConfirmDialog testId="confirm-diloag">
            <ConfirmDialog.Message>{dialogMessage}</ConfirmDialog.Message>
            <ConfirmDialog.ActionButtons>
              <ConfirmDialog.Button
                className="dialog-btn"
                onClick={this.handleOkClick}
              >
                {this.props.labels.okLabel}
              </ConfirmDialog.Button>
            </ConfirmDialog.ActionButtons>
          </ConfirmDialog>
        )}
        {!isLoading && (
          <React.Fragment>
            {currentViewHash == "home" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && <Dashboard token={token} />}
            {currentViewHash == "opportunites" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && <Opportunity token={token} Currencies={Currencies} />}
            {currentViewHash == "collaborations" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Collaboration
                  token={token}
                  Currencies={Currencies}
                  locationProp={location}
                />
              )}
            {currentViewHash == "finish-collaboration" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Collaboration
                  token={token}
                  Currencies={Currencies}
                  locationProp={location}
                />
              )}
            {/* {currentViewHash == "start-new-search" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <StartNewSearch />
              )}
            {currentViewHash == "approve-time-and-expenses" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Reports />
              )}           */}
          </React.Fragment>
        )}
      </PageWrapper>
    );
  }
}
const mapStateToProps = ({ systemLabel, navigation, userInfo }) => {
  const { labels } = systemLabel;
  const { user } = userInfo;
  const User = user ? user : StorageService.getUser();
  const { isHelpActive } = navigation;
  return { labels, isHelpActive, User };
};
export default connect(
  mapStateToProps,
  { notificationAction }
)(Snapshot);
